export default __webpack_public_path__ + "static/media/shopeeLogo.89488e06.png";